<template>
  <Dialog
    width="765px"
    :height="createRenderType == 'mobile' ? '100%' : '700px'"
    titleAlign="left"
    :title="$$t('create.create_similar')"
    :visible="renderData.visible"
    @close="closeDialog"
    customClass="advance-mode-similar-dialog"
    mobileRenderType="drawerDialog"
  >
    <div
      class="height-all create-advance-mode-similar flex-column"
      :class="{
        'create-advance-mode-similar--mobile': createRenderType == 'mobile',
      }"
    >
      <div class="create-advance-mode-similar-edit flex">
        <CreateEdit :similarData="props.data"></CreateEdit>
      </div>

      <div
        class="create-advance-mode-similar-done-btn-box"
        :class="{
          'create-advance-mode-similar-done-btn-box-vip':
            renderData.renderBtnVip,
        }"
      >
        <div class="create-advance-mode-similar-credits" @click="goBuyCredits">
          <span class="create-submit-credits-text fn-inline">
            {{ $$t("create.credits_remaining") }}
            {{ renderData.userCredits }}
          </span>
        </div>

        <div class="create-advance-mode-similar-tips flex">
          <i></i>
          <span class="create-submit-tips-text fn-inline">
            {{
              $$tValue("create.count_pro_features_activated", {
                count: renderData.renderBtnVipCount,
              })
            }}
          </span>
        </div>
        <div class="create-advance-mode-similar-done-btn">
          <Button
            @click="onDoneClick"
            v-if="renderData.renderBtnVip"
            :loading="renderData.isLoading"
            :renderStyle="{
              '--padding': '0 35px',
              '--width': '100%',
              '--height': '48px',
              '--borderRadius': '50px',
              '--fontColor': '#000',
              '--fontSize': '16px',
              '--fontWeight': 'normal',
              '--border': 'none',
              '--background':
                'linear-gradient(263deg, rgba(137, 122, 255, 1) 0%, rgba(255, 216, 203, 1) 50%, rgba(177, 146, 255, 1) 100%)',
              '--backgroundHover':
                'linear-gradient(263deg, rgba(137, 122, 255, 0.75) 0%, rgba(255, 216, 203, 0.75) 50%, rgba(177, 146, 255, 0.75) 100%)',
              '--fontColorHover': '#000',
            }"
          >
            <i class="ico-lock icon"></i>
            <span> {{ $$t("create.unlock_to_create") }} </span>
          </Button>

          <Button
            v-if="!renderData.renderBtnVip"
            @click="onDoneClick"
            :loading="renderData.isLoading"
            :renderStyle="{
              '--padding': '0 35px',
              '--width': '100%',
              '--height': '48px',
              '--borderRadius': '50px',
              '--fontColor': '#000',
              '--fontSize': '16px',
              '--fontWeight': 'normal',
              '--border': 'none',
              '--background':
                'linear-gradient(263deg, rgba(137, 122, 255, 1) 0%, rgba(255, 216, 203, 1) 50%, rgba(177, 146, 255, 1) 100%)',
              '--backgroundHover':
                'linear-gradient(263deg, rgba(137, 122, 255, 0.75) 0%, rgba(255, 216, 203, 0.75) 50%, rgba(177, 146, 255, 0.75) 100%)',
              '--fontColorHover': '#000',
            }"
          >
            {{ $$t("create.create") }}
          </Button>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue"
import { useRouter, useRoute } from "vue-router"
import message from "@/components/functionCallComponent/message.jsx"
import CreateEdit from "@/page/instrumental/createEdit.vue"

import feedListApi from "@/api/api/feedListApi.js"
import Dialog from "@/components/basic/dialog/Dialog.vue"
import Button from "@/components/basic/button/Button.vue"

import { storeToRefs } from "pinia"
import useCreateLayoutStore from "@/store/create/createLayoutStore.js"
import useUserDataStore from "@/store/userDataStore.js"
import useFeedListStore from "@/store/create/feedListDataStore.js"
import useMuseDataStore from "@/store/create/museDataStore.js"
import useDraftDataStore from "@/store/create/draftDataStore.js"

const userDataStore = useUserDataStore()

const createLayoutStore = useCreateLayoutStore()
const feedListDataStore = useFeedListStore()
const museDataStore = useMuseDataStore()
const draftDataStore = useDraftDataStore()

const { createRenderType } = storeToRefs(createLayoutStore)
const globalProperties = (
  getCurrentInstance() || window?.$getVueCurrentInstance?.()
).appContext?.config?.globalProperties

const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const Router = (getCurrentInstance() || window?.$getVueCurrentInstance?.())
  .appContext?.config?.globalProperties?.$router
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  visible: {
    type: Boolean,
    default: true,
  },
})
const emits = defineEmits(["update:visible", "done", "close"])

const refInput = ref(null)
const renderData = reactive({
  visible: props.visible,
  userCredits: userDataStore.isLogin ? userDataStore.credits ?? 0 : 0,
  renderBtnVip: false,
  renderBtnVipCount: 0,
  isLoading: false,
})

const onClose = () => {
  renderData.visible = false
  emits("update:visible", false)
  emits("cancel")
}

const onDoneClick = async () => {
  if (renderData.renderBtnVip) {
    goBuyCredits()
  } else {
    renderData.isLoading = true
    feedListDataStore
      .doGenerateBgmSimilarAdvanceMode()
      .then(() => {
        renderData.isLoading = false
        emits("goCreateResult")
      })
      .catch((err) => {
        renderData.isLoading = false
      })
  }
}

const closeDialog = () => {
  renderData.visible = false
  emits("close", false)
}

const goBuyCredits = () => {
  draftDataStore.cacheSimilarAdvanceData(true)

  Router.push({
    name: "subscribe",
    query: {
      from_type: "similar",
      source_route: Router.currentRoute.value.path,
      membership_source1: "create",
      membership_source2: "create_advance_similar",
    },
  })
  nextTick().then(() => {
    closeDialog()
  })
}

const updateRenderBtnVip = () => {
  const museData = museDataStore.getMuseData()
  renderData.renderBtnVipCount = museData.museLeadDataType?.reduce(
    (res, item) => {
      if (
        museData[item]?.is_subscription_privilege &&
        museData[`museLeadDataType_${item}`]
      ) {
        return res + 1
      } else {
        return res
      }
    },
    0
  )
  renderData.renderBtnVip = renderData.renderBtnVipCount > 0
}

watch(
  () => props.visible,
  (val) => {
    renderData.visible = props.visible
  }
)

watch(
  () => {
    return userDataStore.credits
  },
  () => {
    renderData.userCredits = userDataStore.credits ?? 0
  }
)

watch(
  () => {
    return museDataStore.museLeadDataType
  },
  () => {
    updateRenderBtnVip()
  }
)

watch(
  () => {
    return userDataStore.userInfo
  },
  () => {
    updateRenderBtnVip()
  }
)

watch(
  () => museDataStore.timescamp,
  () => {
    updateRenderBtnVip()
  }
)

watch(
  () => {
    return userDataStore.isLogin
  },
  () => {
    renderData.userCredits = userDataStore.isLogin
      ? userDataStore.credits ?? 0
      : 2
  }
)

watch(
  () => renderData.visible,
  (val) => {
    emits("update:visible", val)
  }
)

onMounted(() => {
  updateRenderBtnVip()
  renderData.visible = props.visible
})

defineExpose({
  update: () => {
    updateRenderBtnVip()
  },
})
</script>
<style lang="scss">
.custom-dialog.advance-mode-similar-dialog {
  .dialog-box {
    background: linear-gradient(
      129deg,
      #3b3b96 7%,
      #2e1953 47%,
      #361469 100%
    ) !important;
  }
  &.drawer-dialog {
    .dialog-box {
      background: transparent !important;
      background-image: url(@/assets/img/main-bg-mobile-wp.webp) !important;
      background-size: 100% 100% !important;
    }
  }
}

.create-advance-mode-similar {
  padding: 13px 40px 32px 40px;

  .create-advance-mode-similar-edit {
    height: 0;
    flex: 1;
    padding: 0;
    .create-instrumental-edit-content-box {
      width: 100% !important;
      background: unset;
      backdrop-filter: unset;
      transform: unset !important;
    }
    .create-instrumental-edit {
      border-right: none;
    }
    .create-instrumental-edit-box {
      margin: 0!important;
    }
    .create-mode-switch-box {
      display: none;
    }
    .create-submit {
      display: none;
    }
    .create-edit-content-box {
      position: relative;
      transform: unset !important;
    }
  }
  .custom-button .el-button .el-icon.is-loading {
    background-image: url(@/assets/img/loading-mini-white-3x.png) !important;
    background-size: 100% 100% !important;
  }
  &.create-advance-mode-similar--mobile {
    .create-advance-mode-similar-edit {
      .create-instrumental-edit-content-box {
        height: 100%;
        position: unset;
      }
      .create-instrumental-edit-content {
        padding: 0;
        background-image: unset;
      }
    }
  }

  .create-advance-mode-similar-tips {
    align-items: center;
    justify-content: end;
    flex: 1;
    width: 0;
    margin: 0 8px;
    i {
      height: 20px;
      width: 20px;
      background: url("@/assets/img/crown-ico.png") no-repeat;
      background-size: 100% 100%;
    }
    span {
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      display: flex;
      align-items: center;
      color: #ffe95e;
      margin: 0 0 0 8px;
    }
  }

  .create-advance-mode-similar-done-btn-box {
    margin: 24px 0 0 0;
    padding: 0 0 0 16px;
    display: flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 48px;
    justify-content: space-between;
    .create-advance-mode-similar-credits {
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      align-items: center;
      letter-spacing: 0.02em;
      color: #ffffff;
    }
    .create-advance-mode-similar-tips {
      display: none;
    }
    .create-advance-mode-similar-done-btn {
      .ico-lock {
        width: 20px;
        height: 20px;
        background: url("@/assets/img/lock-black-ico.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 4px 0 0;
      }
    }
    &.create-advance-mode-similar-done-btn-box-vip {
      .create-advance-mode-similar-tips {
        display: flex;
      }
    }
  }
  &.create-advance-mode-similar--mobile {
    padding: 15px 16px 16px 16px;
    .create-advance-mode-similar-done-btn-box {
      padding: 0 0 0 16px;
      .create-advance-mode-similar-done-btn {
        margin: unset;
      }

      .create-advance-mode-similar-tips {
        justify-content: start;
        padding: 0 0 0 0px;
      }
      &.create-advance-mode-similar-done-btn-box-vip {
        .create-advance-mode-similar-credits {
          display: none;
        }
        .create-advance-mode-similar-tips {
          display: flex;
        }
      }
    }
  }
}
</style>
